import Button from 'antd/es/button';
import Result from 'antd/es/result';
import type { FC } from 'react';
import { useNavigate } from 'react-router';

const NotAllowedPage: FC = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '24px',
        width: '100%',
      }}
    >
      <Result
        status="403"
        title="403"
        subTitle="You are not allowed to visit this page."
        extra={
          <Button type="primary" onClick={() => navigate('/')}>
            Back Home
          </Button>
        }
      />
    </div>
  );
};

export default NotAllowedPage;
